import styled from "styled-components";
import { getAuthStatusTranslate } from "@/pages/profile/helper/getAuthStatusTranslate";
import { AuthStatus } from "project-config/constants";

export function ProfileAuthStatus({
  status,
  isStudent,
  onClick,
  isPersonal,
}: {
  status?: number;
  isStudent?: boolean;
  onClick?: () => void;
  isPersonal?: boolean;
}) {
  return (
    <ProfileAuthStatusWrapper
      className={`status-${
        status === AuthStatus.Changing && isPersonal
          ? AuthStatus.PersonalAuthSuccess
          : status
      }`}
      onClick={() => onClick?.()}
    >
      {getAuthStatusTranslate(status!, isStudent, isPersonal)}
    </ProfileAuthStatusWrapper>
  );
}

const ProfileAuthStatusWrapper = styled.div`
  min-width: 52px;
  height: 20px;
  padding: 0 8px;
  line-height: 20px;
  text-align: center;
  border-radius: 2px;
  background: #60646b;
  font-size: 12px;
  cursor: pointer;
  &.status-11,
  &.status-10,
  &.status-9,
  &.status-6,
  &.status-7 {
    color: #503000;
    background: linear-gradient(261.59deg, #ffbe83 0%, #fff4d8 100%);
  }
  &.status-2 {
    background: rgba(19, 203, 117, 0.6);
  }
  &.status-12,
  &.status-5 {
    background: rgba(0, 108, 255, 0.6);
  }
  &.status-4 {
    background: rgba(255, 153, 0, 0.6);
  }
`;
